/**
 * Provides ability to track using Google analytics.
 */
define([], () => {
    return (ga, config, plugins = []) => {
        function trackPageView({payload: {path}}) {
            ga('set', {
                page: path
            });
            ga('send', {
                hitType: 'pageview'
            });
        }

        function trackServerCall({payload: {success, elapsedTime, path, method}}) {
            ga('send', {
                hitType: 'event',
                eventCategory: 'serverCall',
                eventAction: `${path}:${method}`,
                eventLabel: success ? 'success' : 'failure',
                eventValue: elapsedTime
            });
        }

        function trackWizard({eventName}) {
            ga('send', {
                hitType: 'event',
                eventCategory: 'wizard',
                eventAction: eventName
            });
        }

        function trackPurchase({payload: {id, offering, taxes, total, productName}}) {
            ga('ecommerce:addTransaction', {
                id,
                revenue: total.amount,
                tax: taxes.amount,
                currency: total.currency
            });
            ga('ecommerce:addItem', {
                id,
                name: productName,
                category: offering,
                price: total.amount - taxes.amount,
                currency: total.currency
            });
            ga('ecommerce:send');
        }

        // Create a new tracker
        ga('create', config);
        plugins.forEach(pluginName => ga('require', pluginName));
        return {
            trackPageView,
            trackServerCall,
            trackWizard,
            trackPurchase
        };
    };
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/tracking/adapters/GoogleAnalyticsAdapter.js